<template>
  <div>
    <!-- ==================== HERO ==================== -->
    <section class="fl-hero">
      <div class="fl-hero__glow"></div>
      <div class="fl-wrap">
        <div class="fl-hero__grid">
          <div class="fl-hero__copy">
            <span class="fl-eyebrow" data-reveal="0"
              >İçerik üreticileri için affiliate platformu</span
            >

            <h1 class="fl-h1" data-reveal="60">
              Ürettiğin içerik<br />
              <span class="fl-underline">gelire</span> dönüşsün.
            </h1>

            <p class="fl-lead" data-reveal="120">
              Link üret, kampanyalara katıl, hak edişini kuruşu kuruşuna takip
              et. Marka başvurusundan onaya, yayından ödemeye kadar tüm süreç
              tek uygulamada — kağıt, e-posta trafiği ve “ödemem ne oldu?”
              mesajları olmadan.
            </p>

            <div class="fl-hero__actions" data-reveal="180">
              <a class="fl-btn fl-btn--primary" href="/account/register">
                Ücretsiz Başla
                <i class="mdi mdi-arrow-right"></i>
              </a>
              <a
                class="fl-btn fl-btn--ghost"
                href="javascript:void(0)"
                @click="scrollTo('kampanyalar')"
              >
                <i class="mdi mdi-play-circle-outline"></i>
                Nasıl çalışır?
              </a>
            </div>

            <div class="fl-hero__note" data-reveal="240">
              <i class="mdi mdi-check-circle" style="color: #f85617"></i>
              Kayıt ücretsiz · Komisyon yalnızca kazandığında
            </div>
          </div>

          <!-- Telefon maketi -->
          <div class="fl-phone-stage" data-reveal="140">
            <div class="fl-float fl-float--a">
              <div class="fl-float__dot">
                <i class="mdi mdi-cursor-default-click-outline"></i>
              </div>
              <div>
                <b>1.248</b>
                <span>bu ay tıklama</span>
              </div>
            </div>

            <div class="fl-phone fl-phone--shot">
              <div class="fl-phone__notch"></div>
              <div class="fl-phone__screen">
                <img
                  class="fl-phone__shot"
                  src="@/assets/images/app/home.webp"
                  alt="FantasLink mobil uygulaması ana sayfa ekranı: toplam kazanç kartı ve açık kampanyaların adım takibi"
                />
              </div>
            </div>

            <div class="fl-float fl-float--b">
              <div class="fl-float__dot">
                <i class="mdi mdi-check-decagram-outline"></i>
              </div>
              <div>
                <b>İçerik onaylandı</b>
                <span>Yayın: 12 Eylül</span>
              </div>
            </div>
          </div>
        </div>

        <!-- İstatistik şeridi -->
        <div class="fl-stats" data-reveal="0">
          <div class="fl-stat">
            <div class="fl-stat__n">1.500+</div>
            <div class="fl-stat__l">Tamamlanan proje</div>
          </div>
          <div class="fl-stat">
            <div class="fl-stat__n">600M+</div>
            <div class="fl-stat__l">Toplam erişim</div>
          </div>
          <div class="fl-stat">
            <div class="fl-stat__n">4</div>
            <div class="fl-stat__l">Adımda kampanya süreci</div>
          </div>
          <div class="fl-stat">
            <div class="fl-stat__n">7/24</div>
            <div class="fl-stat__l">Kazanç ve tıklama takibi</div>
          </div>
        </div>
      </div>
    </section>

    <!-- ==================== MARQUEE ==================== -->
    <div class="fl-marquee">
      <div class="fl-marquee__track">
        <div
          v-for="(item, i) in marqueeLoop"
          :key="i"
          class="fl-marquee__item"
        >
          {{ item }}
        </div>
      </div>
    </div>

    <!-- ==================== ÖZELLİKLER ==================== -->
    <section id="ozellikler" class="fl-section">
      <div class="fl-wrap">
        <div class="fl-head">
          <div>
            <span class="fl-eyebrow" data-reveal="0">Platform</span>
            <h2 class="fl-h2" data-reveal="60">
              Bir içerik üreticisinin<br />ihtiyacı olan her şey.
            </h2>
          </div>
          <p class="fl-lead" data-reveal="120">
            Link kısaltmadan hak ediş dekontuna kadar dağınık şekilde yürüyen
            işleri tek panelde topladık. Excel, WhatsApp grubu ve e-posta
            zincirlerine gerek kalmıyor.
          </p>
        </div>

        <div class="fl-bento">
          <div class="fl-card fl-card--wide" data-reveal="0">
            <div class="fl-card__ico">
              <i class="mdi mdi-link-variant-plus"></i>
            </div>
            <h3>Akıllı affiliate link üretimi</h3>
            <p>
              Herhangi bir ürün ya da kategori bağlantısını yapıştır; sistem
              markayı otomatik tanısın, izlenebilir kısa linki üretsin ve
              panoya kopyalasın. Uygulama içi mağaza tarayıcısıyla gezerken
              baktığın sayfayı tek dokunuşla linke çevirebilirsin.
            </p>
            <div class="fl-demo">
              <div class="fl-demo__from">
                https://www.marka.com/kadin/bot-p-482913?boutiqueId=61…
              </div>
              <div class="fl-demo__to">
                <i class="mdi mdi-arrow-down"></i> fantaslink.com/kis-botu
              </div>
            </div>
          </div>

          <div class="fl-card fl-card--third" data-reveal="80">
            <div class="fl-card__ico"><i class="mdi mdi-wallet-outline"></i></div>
            <h3>Kazanç merkezi</h3>
            <p>
              Kullanılabilir ve bekleyen kazancın, tıklama sayın, dönüşüm oranın
              ve 7 gün / 30 gün / 3 ay kırılımında performans grafiğin tek
              ekranda.
            </p>
          </div>

          <div class="fl-card fl-card--third" data-reveal="160">
            <div class="fl-card__ico">
              <i class="mdi mdi-file-document-outline"></i>
            </div>
            <h3>Şeffaf hak ediş</h3>
            <p>
              Her dönem için brüt tutar, platform komisyonu, stopaj ve tevkifat
              ayrı ayrı gösterilir. Net ödemenin nasıl oluştuğunu satır satır
              görürsün.
            </p>
          </div>

          <div class="fl-card fl-card--third" data-reveal="0">
            <div class="fl-card__ico">
              <i class="mdi mdi-view-grid-outline"></i>
            </div>
            <h3>Koleksiyonlar</h3>
            <p>
              Favori ürünlerini temaya göre grupla, tek bir paylaşılabilir
              sayfaya dönüştür ve profil bio’na koy. Vitrinin sürekli çalışsın.
            </p>
          </div>

          <div class="fl-card fl-card--third" data-reveal="80">
            <div class="fl-card__ico">
              <i class="mdi mdi-ticket-percent-outline"></i>
            </div>
            <h3>Kişiye özel kuponlar</h3>
            <p>
              Markaların sana özel tanımladığı indirim kodları hesabında
              görünür. Kitlene avantaj sunarken dönüşümünü yükseltirsin.
            </p>
          </div>

          <div class="fl-card fl-card--third" data-reveal="160">
            <div class="fl-card__ico">
              <i class="mdi mdi-storefront-outline"></i>
            </div>
            <h3>Marka başvuruları</h3>
            <p>
              Komisyon oranlarıyla birlikte listelenen markalara başvur,
              başvurunun durumunu (aktif · inceleniyor · açık) anlık takip et.
            </p>
          </div>

          <div class="fl-card fl-card--half" data-reveal="0">
            <div class="fl-card__ico">
              <i class="mdi mdi-lifebuoy"></i>
            </div>
            <h3>Destek ve bilgilendirme</h3>
            <p>
              Üyelik, ödeme ya da kampanya konusunda destek talebi aç, ekiple
              uygulama içinden yazış. Duyurular WhatsApp kanalına düşsün, hiçbir
              kampanya fırsatını kaçırma.
            </p>
          </div>

          <div class="fl-card fl-card--half" data-reveal="80">
            <div class="fl-card__ico">
              <i class="mdi mdi-shield-check-outline"></i>
            </div>
            <h3>Mevzuata uygun altyapı</h3>
            <p>
              KVKK onay akışı, yeni sosyal medya kazanç istisnası için belge ve
              IBAN yönetimi, kurumsal bilgiler ve fatura süreçleri sistemin
              içinde çözülür.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- ==================== İÇERİK KAMPANYALARI ==================== -->
    <section id="kampanyalar" class="fl-section fl-section--cream">
      <div class="fl-wrap">
        <div class="fl-head">
          <div>
            <span class="fl-eyebrow" data-reveal="0">İçerik Kampanyaları</span>
            <h2 class="fl-h2" data-reveal="60">
              Brief’ten istatistiğe,<br />tek akış.
            </h2>
          </div>
          <p class="fl-lead" data-reveal="120">
            Marka brief’i yayınlar, içerik üreticisi taslağını yükler, onay ya
            da revizyon aynı ekrandan döner, yayın tarihi netleşir ve süreç
            istatistikle kapanır. Kim hangi adımda — herkes aynı anda görür.
          </p>
        </div>

        <div class="fl-steps" data-reveal="0">
          <div class="fl-step">
            <div class="fl-step__n">01</div>
            <h3>İçerik</h3>
            <p>
              Zengin metinli brief’i, kapak görselini ve brief dokümanını oku;
              zorunlu hashtag, etiket ve linkleri gör. Taslak görselini ya da
              videonu yükle.
            </p>
          </div>
          <div class="fl-step">
            <div class="fl-step__n">02</div>
            <h3>Onay</h3>
            <p>
              Operasyon ekibi içeriği inceler. Onay çıkarsa yayın tarihin
              bildirilir; revizyon gerekiyorsa notu okuyup aynı satırdan yeniden
              yüklersin.
            </p>
          </div>
          <div class="fl-step">
            <div class="fl-step__n">03</div>
            <h3>Yayın</h3>
            <p>
              İçeriği verilen tarihte paylaş ve gönderi linkini sisteme gir.
              Kampanya “yayınlandı” durumuna geçer, 24 saatlik sayaç başlar.
            </p>
          </div>
          <div class="fl-step">
            <div class="fl-step__n">04</div>
            <h3>İstatistik</h3>
            <p>
              24 saat dolunca istatistik alanı açılır. Story verilerini yükle,
              süreç tamamlansın ve hak edişin ödeme takibine düşsün.
            </p>
          </div>
        </div>

        <!-- Gerçek uygulama ekranları -->
        <div class="fl-showcase">
          <div class="fl-showcase__copy" data-reveal="0">
            <span class="fl-eyebrow">Uygulamada</span>
            <h3 class="fl-h2" style="font-size: clamp(26px, 3vw, 38px)">
              Süreç tam olarak böyle görünüyor.
            </h3>
            <p class="fl-lead">
              Kampanya kartına dokunduğun anda hangi adımda olduğunu, brief’in
              tamamını ve zorunlu etiketleri görürsün. Ekranda gördüklerin
              temsili değil — uygulamanın gerçek arayüzü.
            </p>
            <ul class="fl-showcase__list">
              <li>
                <i class="mdi mdi-numeric-1-circle-outline"></i>
                <span
                  >Numaralı adım göstergesi: içerik, onay, yayın, istatistik</span
                >
              </li>
              <li>
                <i class="mdi mdi-format-list-checks"></i>
                <span
                  >Brief metni, kapak görseli ve teslim edilecekler listesi</span
                >
              </li>
              <li>
                <i class="mdi mdi-pound"></i>
                <span
                  >Zorunlu hashtag ve etiketler ayrı rozetler halinde</span
                >
              </li>
              <li>
                <i class="mdi mdi-timer-sand"></i>
                <span
                  >Durum rozeti: kayıt oldu, inceleniyor, onaylandı,
                  yayınlandı</span
                >
              </li>
            </ul>
          </div>

          <div class="fl-showcase__phones" data-reveal="80">
            <div class="fl-phone fl-phone--shot is-back">
              <div class="fl-phone__notch"></div>
              <div class="fl-phone__screen">
                <img
                  class="fl-phone__shot"
                  src="@/assets/images/app/campaigns.webp"
                  alt="Uygulamadaki içerik kampanyaları listesi ve durum rozetleri"
                />
              </div>
            </div>
            <div class="fl-phone fl-phone--shot is-front">
              <div class="fl-phone__notch"></div>
              <div class="fl-phone__screen">
                <img
                  class="fl-phone__shot"
                  src="@/assets/images/app/campaign.webp"
                  alt="İçerik kampanyası detay ekranı: dört adımlı süreç göstergesi, brief ve zorunlu hashtagler"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="fl-roles" style="margin-top: clamp(40px, 5vw, 72px)">
          <div class="fl-role fl-role--accent" data-reveal="0">
            <span class="fl-role__tag">Influencer</span>
            <h3>Hesap açmadan bile katıl</h3>
            <ul>
              <li>
                <i class="mdi mdi-check"></i> Keşfet akışındaki açık
                kampanyalara tek dokunuşla başvur
              </li>
              <li>
                <i class="mdi mdi-check"></i> Uygulamadan ya da sana özel
                portal linkinden aynı sürece devam et
              </li>
              <li>
                <i class="mdi mdi-check"></i> Adım adım ilerleme çubuğuyla
                nerede olduğunu gör
              </li>
              <li>
                <i class="mdi mdi-check"></i> Onay, revizyon ve istatistik
                hatırlatmaları e-posta ile gelsin
              </li>
            </ul>
          </div>

          <div class="fl-role" data-reveal="80">
            <span class="fl-role__tag">Marka</span>
            <h3>Kampanyayı uçtan uca yönet</h3>
            <ul>
              <li>
                <i class="mdi mdi-check"></i> Brief, kapak medyası ve doküman
                yükleyerek kampanya aç
              </li>
              <li>
                <i class="mdi mdi-check"></i> Zorunlu hashtag, etiket, link ve
                yayın tarihi tanımla
              </li>
              <li>
                <i class="mdi mdi-check"></i> Gelen taslakları önizle, onayla
                ya da not yazarak revizyon iste
              </li>
              <li>
                <i class="mdi mdi-check"></i> Tüm içerikleri ve raporu Excel /
                ZIP olarak dışa aktar
              </li>
            </ul>
          </div>

          <div class="fl-role" data-reveal="160">
            <span class="fl-role__tag">Ajans</span>
            <h3>Yüzlerce influencer’ı tek tabloda</h3>
            <ul>
              <li>
                <i class="mdi mdi-check"></i> Şifre korumalı ajans paneliyle
                kendi listene eriş
              </li>
              <li>
                <i class="mdi mdi-check"></i> Her influencer adına taslak,
                gönderi ve istatistik yükle
              </li>
              <li>
                <i class="mdi mdi-check"></i> Durum filtreleri ve canlı
                sayaçlarla kim nerede kaldı gör
              </li>
              <li>
                <i class="mdi mdi-check"></i> Instagram adına göre ara, tabloyu
                anlık takip et
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- ==================== MOBİL UYGULAMA ==================== -->
    <section id="uygulama" class="fl-section fl-section--ink2">
      <div class="fl-wrap">
        <div class="fl-download" data-reveal="0">
          <div class="fl-download__grid">
            <div>
              <span class="fl-eyebrow">Mobil uygulama</span>
              <h2 class="fl-h2" style="margin-top: 18px">
                Kazancın cebinde.
              </h2>
              <p class="fl-lead" style="margin-top: 18px">
                FantasLink mobil uygulaması iOS ve Android’de ücretsiz. Link
                üretmek, kampanya sürecini yürütmek ve hak edişini görmek için
                bilgisayara oturmana gerek yok.
              </p>

              <ul class="fl-download__list">
                <li>
                  <i class="mdi mdi-content-paste"></i>
                  <span
                    >Panodan yapıştır, markayı otomatik tanısın, link anında
                    kopyalansın</span
                  >
                </li>
                <li>
                  <i class="mdi mdi-compass-outline"></i>
                  <span
                    >Keşfet sekmesinde sana açık kampanyaları gör, tek
                    dokunuşla başvur</span
                  >
                </li>
                <li>
                  <i class="mdi mdi-progress-check"></i>
                  <span
                    >İçerik yükleme, onay, yayın ve istatistik adımlarını
                    uygulamadan tamamla</span
                  >
                </li>
                <li>
                  <i class="mdi mdi-chart-box-outline"></i>
                  <span
                    >Tıklama, dönüşüm ve dönem bazlı ödeme dökümünü grafiklerle
                    izle</span
                  >
                </li>
                <li>
                  <i class="mdi mdi-cellphone-link"></i>
                  <span
                    >E-postadaki kampanya bağlantısı doğrudan uygulamada
                    açılsın</span
                  >
                </li>
              </ul>

              <div class="fl-stores">
                <a
                  class="fl-store"
                  :href="storeLinks.ios"
                  target="_blank"
                  rel="noopener"
                >
                  <i class="mdi mdi-apple"></i>
                  <span class="fl-store__t">
                    <small>İndir</small>
                    <b>App Store</b>
                  </span>
                </a>
                <a
                  class="fl-store"
                  :href="storeLinks.android"
                  target="_blank"
                  rel="noopener"
                >
                  <i class="mdi mdi-google-play"></i>
                  <span class="fl-store__t">
                    <small>İndir</small>
                    <b>Google Play</b>
                  </span>
                </a>
              </div>

              <div class="fl-download__qr">
                <i class="mdi mdi-information-outline" style="font-size: 18px"></i>
                Ücretsiz · Türkçe · iOS 13+ ve Android 8+
              </div>
            </div>

            <!-- Üç gerçek uygulama ekranı, yelpaze düzeninde -->
            <div class="fl-fan">
              <div class="fl-phone fl-phone--shot fl-fan__back-l">
                <div class="fl-phone__notch"></div>
                <div class="fl-phone__screen">
                  <img
                    class="fl-phone__shot"
                    src="@/assets/images/app/earnings.webp"
                    alt="Kazanç merkezi ekranı: toplam kazanç, tıklama, dönüşüm oranı ve performans grafiği"
                  />
                </div>
              </div>

              <div class="fl-phone fl-phone--shot fl-fan__back-r">
                <div class="fl-phone__notch"></div>
                <div class="fl-phone__screen">
                  <img
                    class="fl-phone__shot"
                    src="@/assets/images/app/profile.webp"
                    alt="Profil ekranı: profil tamamlanma çubuğu, takipçi ve etkileşim kartları"
                  />
                </div>
              </div>

              <div class="fl-phone fl-phone--shot fl-fan__front">
                <div class="fl-phone__notch"></div>
                <div class="fl-phone__screen">
                  <img
                    class="fl-phone__shot"
                    src="@/assets/images/app/link.webp"
                    alt="Link oluşturma ekranı: ürün linkini yapıştır, affiliate link üret ve son linklerin performansını gör"
                  />
                </div>
                <span class="fl-shotcap">Gerçek uygulama ekranı</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ==================== BLOG ==================== -->
    <section class="fl-section fl-section--cream">
      <div class="fl-wrap">
        <div class="fl-head">
          <div>
            <span class="fl-eyebrow" data-reveal="0">Bilgi merkezi</span>
            <h2 class="fl-h2" data-reveal="60">
              İçerik üreticisi<br />rehberleri.
            </h2>
          </div>
          <div data-reveal="120">
            <p class="fl-lead">
              Affiliate’in nasıl işlediğinden vergi mevzuatına, fiyat
              belirlemeden etkileşim artırmaya: işini büyütmene yarayan
              yazılar.
            </p>
            <router-link
              to="/blog"
              class="fl-btn fl-btn--ghost"
              style="margin-top: 20px"
            >
              Tüm yazılar
              <i class="mdi mdi-arrow-right"></i>
            </router-link>
          </div>
        </div>

        <div class="fl-posts">
          <router-link
            v-for="(post, i) in latestPosts"
            :key="post.slug"
            :to="'/blog/' + post.slug"
            class="fl-post"
            :data-reveal="i * 80"
          >
            <div class="fl-post__cover" :style="{ background: post.cover }">
              <i class="mdi" :class="post.icon"></i>
            </div>
            <div class="fl-post__body">
              <div class="fl-post__meta">
                <span>{{ post.category }}</span>
                <span>·</span>
                <span>{{ post.readMinutes }} dk okuma</span>
              </div>
              <h3>{{ post.title }}</h3>
              <p>{{ post.excerpt }}</p>
              <span class="fl-post__more">
                Yazıyı oku <i class="mdi mdi-arrow-right"></i>
              </span>
            </div>
          </router-link>
        </div>
      </div>
    </section>

    <!-- ==================== SSS ==================== -->
    <section id="sss" class="fl-section">
      <div class="fl-wrap">
        <div class="fl-head">
          <div>
            <span class="fl-eyebrow" data-reveal="0">SSS</span>
            <h2 class="fl-h2" data-reveal="60">Merak edilenler</h2>
          </div>
          <p class="fl-lead" data-reveal="120">
            Aradığını bulamadıysan uygulama içindeki destek talebi ekranından
            bize yazabilirsin.
          </p>
        </div>

        <div class="fl-faq" data-reveal="0">
          <div
            v-for="(item, i) in faq"
            :key="i"
            class="fl-faq__item"
            :class="{ 'is-open': openFaq === i }"
          >
            <button
              class="fl-faq__q"
              type="button"
              :aria-expanded="openFaq === i ? 'true' : 'false'"
              @click="toggleFaq(i)"
            >
              {{ item.q }}
              <i class="mdi mdi-plus"></i>
            </button>
            <div class="fl-faq__a">
              <p>{{ item.a }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ==================== KAPANIŞ CTA ==================== -->
    <section class="fl-cta">
      <div class="fl-cta__glow"></div>
      <div class="fl-wrap">
        <div class="fl-cta__inner">
          <span class="fl-eyebrow" data-reveal="0">Hazırsan başlayalım</span>
          <h2 class="fl-h2" data-reveal="60" style="max-width: 16ch">
            İlk linkini bugün oluştur.
          </h2>
          <p class="fl-lead" data-reveal="120">
            Kayıt ücretsiz, taahhüt yok. Profilini tamamla, markalara başvur ve
            ilk kampanyana katıl.
          </p>
          <div class="fl-hero__actions" data-reveal="180" style="justify-content: center">
            <a class="fl-btn fl-btn--primary" href="/account/register">
              Ücretsiz Kayıt Ol
              <i class="mdi mdi-arrow-right"></i>
            </a>
            <a
              class="fl-btn fl-btn--ghost"
              :href="storeLinks.ios"
              target="_blank"
              rel="noopener"
            >
              <i class="mdi mdi-cellphone-arrow-down"></i>
              Uygulamayı İndir
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from "vue-property-decorator";
import { blogPosts } from "../blog-posts";
import { initReveal } from "../reveal";

@Component
export default class MarketingHome extends Vue {
  public openFaq: number | null = 0;
  private teardown: (() => void) | null = null;

  public storeLinks = {
    ios: "https://apps.apple.com/us/app/fantaslink/id1620421041",
    android:
      "https://play.google.com/store/apps/details?id=com.fantaslink",
  };

  public marqueeItems = [
    "Affiliate link üretimi",
    "İçerik kampanyaları",
    "Koleksiyonlar",
    "Kupon kodları",
    "Kazanç raporu",
    "Hak ediş takibi",
    "Marka başvuruları",
    "Ajans paneli",
  ];

  public faq = [
    {
      q: "FantasLink’i kullanmak ücretli mi?",
      a: "Hayır. Kayıt olmak ve uygulamayı kullanmak tamamen ücretsizdir. Platform yalnızca sen kazandığında, hak edişin üzerinden sözleşmende yazan komisyon oranıyla gelir elde eder.",
    },
    {
      q: "Kaç takipçim olması gerekiyor?",
      a: "Sabit bir alt sınır yok. Markalar başvuruları kendi kriterlerine göre değerlendirir; mikro hesaplar da yüksek etkileşim oranıyla kampanyalara kabul edilebiliyor. Affiliate link üretmek için ise onay beklemene gerek kalmadan hemen başlayabilirsin.",
    },
    {
      q: "Kazancımı ne zaman alırım?",
      a: "Kazançlar fatura dönemleri halinde hesaplanır. Bir satışın hak edişe dönüşmesi için markanın iade süresinin dolması ve satışı onaylaması gerekir. Dönem kapandığında ödeme detay ekranında brüt tutar, komisyon, stopaj ve net ödeme kalemlerini tek tek görürsün.",
    },
    {
      q: "Stopaj kesintisi nedir, platform mu alıyor?",
      a: "Hayır. Stopaj, sosyal içerik üreticiliği kazançları için senin adına devlete ödenen gelir vergisidir. Platform komisyonu ayrı bir satırdır ve dekontta ayrıca gösterilir.",
    },
    {
      q: "Şirketim yok, yine de çalışabilir miyim?",
      a: "Evet. Sosyal medya kazanç istisnası kapsamında şahıs şirketi olmadan da ödeme alabilirsin; bunun için bankada özel hesap açıp vergi dairesinden istisna belgesi almanız gerekir. Uygulamadaki kanun bilgileri ekranından gerekli belge ve IBAN bilgilerini yükleyebilirsin.",
    },
    {
      q: "İçerik kampanyasına katılmak için uygulamayı indirmem şart mı?",
      a: "Hayır. Kampanyalara sana gönderilen kişisel portal linkinden hesap açmadan da katılabilirsin. Uygulamayı kullanırsan tüm kampanyaların, linklerin ve kazancın tek yerde toplanır.",
    },
    {
      q: "İçeriğim onaylanmazsa ne oluyor?",
      a: "Revizyon notu yazılır ve sana iletilir. Notta istenen düzeltmeleri yapıp içeriği aynı ekrandan yeniden yüklersin; süreç kaldığı yerden devam eder, baştan başlamazsın.",
    },
    {
      q: "Hesabımı silebilir miyim?",
      a: "Evet. Uygulamadaki hesap ayarları ekranından hesabını ve verilerini kalıcı olarak silebilirsin.",
    },
  ];

  get latestPosts() {
    return blogPosts.slice(0, 3);
  }

  /** Kesintisiz döngü için içerik iki kez tekrarlanır. */
  get marqueeLoop() {
    return this.marqueeItems.concat(this.marqueeItems);
  }

  public toggleFaq(i: number) {
    this.openFaq = this.openFaq === i ? null : i;
  }

  public scrollTo(id: string) {
    const el = document.getElementById(id);
    if (!el) return;
    window.scrollTo({
      top: el.getBoundingClientRect().top + window.pageYOffset - 84,
      behavior: "smooth",
    });
  }

  public mounted() {
    this.teardown = initReveal(this.$el);
  }

  public beforeDestroy() {
    if (this.teardown) this.teardown();
  }
}
</script>
